package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class TimetableSlotBulkCreateRequest(
    @SerialName("schedule_type") val scheduleType: String = "REGULAR",
    @SerialName("slot_order") val slotOrder: Int,
    @SerialName("from_time") val fromTime: String,
    @SerialName("to_time") val toTime: String
)

@Serializable
data class TimetableCellBulkCreateRequest(
    @SerialName("schedule_type") val scheduleType: String,
    @SerialName("slot_order") val slotOrder: Int,
    @SerialName("apply_to_days") val applyToDays: List<Int>,
    @SerialName("entry_text") val entryText: String
)

@Serializable
data class TimetableCombinedCreateRequest(
    @SerialName("class_section_id") val classSectionId: String,
    @SerialName("class_name") val className: String,
    @SerialName("section_name") val sectionName: String,
    @SerialName("from_date") val fromDate: String,
    @SerialName("to_date") val toDate: String,
    @SerialName("special_schedule_days") val specialScheduleDays: List<Int> = emptyList(),
    @SerialName("weekly_off_days") val weeklyOffDays: List<Int> = emptyList(),
    val status: String = "Not Published",
    val slots: List<TimetableSlotBulkCreateRequest> = emptyList(),
    val cells: List<TimetableCellBulkCreateRequest> = emptyList(),
    @Transient val replaceSlots: Boolean = true
)

@Serializable
data class TimetableCombinedUpdateRequest(
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("from_date") val fromDate: String? = null,
    @SerialName("to_date") val toDate: String? = null,
    @SerialName("special_schedule_days") val specialScheduleDays: List<Int>? = null,
    @SerialName("weekly_off_days") val weeklyOffDays: List<Int>? = null,
    val status: String? = null,
    val slots: List<TimetableSlotBulkCreateRequest>? = null,
    val cells: List<TimetableCellBulkCreateRequest>? = null
)

fun TimetableCombinedCreateRequest.toUpdateRequest() = TimetableCombinedUpdateRequest(
    classSectionId = classSectionId,
    className = className,
    sectionName = sectionName,
    fromDate = fromDate,
    toDate = toDate,
    specialScheduleDays = specialScheduleDays,
    weeklyOffDays = weeklyOffDays,
    status = status,
    slots = slots.takeIf { replaceSlots },
    cells = cells
)
